// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"8285b68c","72":"8beb6c61","213":"b0e8f523","788":"3898e9bf"}[chunkId] + ".chunk.css";
};